/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetOnboardingSnapshotQueryResponse, GetOnboardingSnapshotPathParams, GetOnboardingSnapshot400, GetOnboardingSnapshot401, GetOnboardingSnapshot403, GetOnboardingSnapshot404, GetOnboardingSnapshot409, GetOnboardingSnapshot500 } from "../../types/onboardingController/GetOnboardingSnapshot.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getOnboardingSnapshot } from "../../client/onboardingController/getOnboardingSnapshot.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getOnboardingSnapshotQueryKey = (organizationId: GetOnboardingSnapshotPathParams["organizationId"] | undefined) => [{ url: '/api/organizations/:organizationId/onboarding/', params: {organizationId:organizationId} }] as const

export type GetOnboardingSnapshotQueryKey = ReturnType<typeof getOnboardingSnapshotQueryKey>

export function getOnboardingSnapshotQueryOptions(organizationId: GetOnboardingSnapshotPathParams["organizationId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getOnboardingSnapshotQueryKey(organizationId)
        return queryOptions<GetOnboardingSnapshotQueryResponse, ResponseErrorConfig<GetOnboardingSnapshot400 | GetOnboardingSnapshot401 | GetOnboardingSnapshot403 | GetOnboardingSnapshot404 | GetOnboardingSnapshot409 | GetOnboardingSnapshot500>, GetOnboardingSnapshotQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getOnboardingSnapshot(organizationId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get the organization onboarding snapshot for the caller
 * {@link /api/organizations/:organizationId/onboarding/}
 */
export function useGetOnboardingSnapshot<TData = GetOnboardingSnapshotQueryResponse, TQueryData = GetOnboardingSnapshotQueryResponse, TQueryKey extends QueryKey = GetOnboardingSnapshotQueryKey>(organizationId: GetOnboardingSnapshotPathParams["organizationId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetOnboardingSnapshotQueryResponse, ResponseErrorConfig<GetOnboardingSnapshot400 | GetOnboardingSnapshot401 | GetOnboardingSnapshot403 | GetOnboardingSnapshot404 | GetOnboardingSnapshot409 | GetOnboardingSnapshot500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getOnboardingSnapshotQueryKey(organizationId)
         

         const query = useQuery({
          ...getOnboardingSnapshotQueryOptions(organizationId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetOnboardingSnapshot400 | GetOnboardingSnapshot401 | GetOnboardingSnapshot403 | GetOnboardingSnapshot404 | GetOnboardingSnapshot409 | GetOnboardingSnapshot500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}